import { forwardRef, ComponentProps } from "react";
import FlexLayoutItem from "../Flexbox/FlexLayoutItem.component";
import FlexLayout from "../Flexbox/FlexLayout.component";
import cx from "classnames";

export default function Card({
  className,
  ...props
}: ComponentProps<typeof FlexLayout> & { className?: string }) {
  return <FlexLayout {...props} className={cx("bg-white rounded-2xl shadow-all", className)} />;
}

export const CardItem = forwardRef<
  HTMLElement,
  ComponentProps<typeof FlexLayoutItem> & { className?: string }
>(({ className, ...props }, ref) => {
  return (
    <FlexLayoutItem
      {...props}
      ref={ref}
      className={cx("bg-white rounded-2xl shadow-all", className)}
    />
  );
});

CardItem.displayName = "CardItem";
